import React from 'react'
import ProductsPriceListHeader from './ProductsPriceListHeader'
import ProductsPriceListInner from './ProductsPriceListInner'
import ProductsPriceListFooter from './ProductsPriceListFooter'
import { getWarehouses, getProductsList } from '../../../../ReportsFunctions'

export const productsPriceListControllerContext = React.createContext()

function useProductsPriceListController(props) {
  return ({
    filter: props.filter,
    getWarehouses,
    getProductsList
  })
}

function ProductsPriceListController(props) {
  const productsPriceListController = useProductsPriceListController(props)
  return (
    <React.Fragment>
      <productsPriceListControllerContext.Provider value={productsPriceListController}>
        <ProductsPriceListHeader />
        <ProductsPriceListInner />
        <ProductsPriceListFooter />
      </productsPriceListControllerContext.Provider>
    </React.Fragment>
  )
}

export default React.memo(ProductsPriceListController)